<template>
  <div class="registered_page">

    <div @click="goBack" class="title">
      <img src="@/assets/img/login/fanhui.png" alt="">
      <span>用户注册</span>
    </div>

    <div class="content">

      <!-- 表单密码 -->
      <div v-if="isShow&&showName !=2" class="tab_form">
        <FromInput :isShow.sync='isShow' />
      </div>

      <div v-if="!isShow&&showName !=2" class="tab_form">
        <FromInputPass :isShow.sync='isShow' :showName.sync=showName />
      </div>

      <div class="succeed" v-if='showName ==2'>
        <img width="90px" height="90px" src="@/assets/img/login/chengg.png" alt="">
        <span>恭喜您注册成功</span>
        <span>请妥善保管您的帐户信息</span>
        <el-button @click="goBack" class="btn_submit">登录</el-button>
      </div>

    </div>

  </div>
</template>

<script>
import FromInput from "./FromInput";
import FromInputPass from "./FromInputPass";
export default {
  name: "RegisteredPage",
  data() {
    return {
      isShow: true,
      showName: 1,
    };
  },
  components: {
    FromInput,
    FromInputPass,
  },
  methods: {
    goBack() {
      this.$emit("update:showName", 1);
    },
  },
};
</script>

<style lang='less' scoped>
.registered_page {
  width: 420px;
  height: 460px;
  padding: 20px 35px 0;
}

.title {
  display: flex;
  align-items: center;
  margin-bottom: 40px;
  cursor: pointer;

  span {
    margin-left: 5px;
    margin-top: -2px;
  }
}

.succeed {
  display: flex;
  flex-direction: column;
  align-items: center;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: rgba(51, 51, 51, 1);

  span:nth-child(2) {
    font-size: 16px;
    margin-top: 35px;
  }

  span:nth-child(3) {
    font-size: 12px;
    color: rgba(135, 135, 135, 1);
    margin-top: 15px;
    margin-bottom: 50px;
  }

  .el-button {
    width: 100%;
    color: #fff;
    background-color: #24ba58;
  }

  .el-button:focus,
  .el-button:hover {
    color: #fff;
  }
}

.el-tabs {
  width: 355px;
  height: 60px;
  position: absolute;
  top: 39px;
  left: 30px;
  padding: 0;
  background-color: #fff;

  /deep/.el-tabs__header {
    margin: 0 0 40px;
  }

  /deep/.el-tabs__item:hover {
    color: #24ba58;
  }

  /deep/.el-tabs__item {
    font-size: 20px;
  }
}

//修改tab样式···················
/deep/.el-tabs__item.is-active {
  color: #24ba58;
}

/deep/.el-tabs__active-bar {
  background-color: #24ba58;
}
</style>